import React from "react";
import Modal from "react-modal";
import "./UI_modalCss.css";
import { New_ScrollX2025 } from "../assets/icons";
import { FaAngleLeft } from "react-icons/fa6";

Modal.setAppElement("#root");

export default function UI_Modal({
  isOpen,
  children,
  closeModal,
  title,
  selectedPlan,
  couponDiscount,
}) {
  const styleModel = {
    content: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "transparent",
      width: "100%",
      height: "100%",
      maxWidth: "100%",
      maxHeight: "100%",
      outline: "none",
      overflow: "hidden",
      padding: "0",
    },
    overlay: { backgroundColor: "rgba(0, 0, 0, 0.7)" },
  };

  return (
    <Modal isOpen={isOpen} style={styleModel} className="user_input_modal">
      <main className="flex w-full h-full overflow-hidden shadow-2xl">
        {/* Left Section */}

        <div className="w-1/2 bg-black flex flex-col items-center justify-center text-white">
          <div className=" w-[52%] flex flex-col gap-[1.2rem]">
            <section className="flex gap-2 items-center">
              <FaAngleLeft
                className="absolute left-[9rem] text-white text-xl cursor-pointer hover:text-gray-300 "
                onClick={closeModal}
              />
              <img className="w-[35px] " src={New_ScrollX2025} />
              <h2 className="font-semibold text-[1.2rem]">ScrollX.io</h2>
            </section>
            <section className="flex flex-col items-start gap-[0.5rem]">
              <p className="text-gray-500 font-semibold text-[1rem]">
                Subscribe to {selectedPlan.type}
              </p>
              <div className="flex gap-[1rem]">
                <p className="text-4xl">
                  {selectedPlan.currency} {selectedPlan.price}.00
                </p>{" "}
                <div className="text-[0.8rem] text-gray-500 flex flex-col justify-between">
                  <p>per {selectedPlan.interval_validity}</p>
                  <p>until cancelled</p>
                </div>
              </div>
            </section>

            <section className="w-full flex items-center justify-between border-b border-[#13141a] pb-[1rem]">
              <div className="flex flex-col gap-1">
                <p className="text-gray-300 text-[0.9rem] font-semibold">
                  {selectedPlan.type}
                </p>
                <p className="text-gray-600 text-[0.7rem]">
                  Billed{" "}
                  {selectedPlan.interval_validity === "day"
                    ? "daily"
                    : selectedPlan.interval_validity === "month"
                    ? "monthly"
                    : selectedPlan.interval_validity === "quarter"
                    ? "quarterly"
                    : ""}{" "}
                  until cancelled
                </p>
              </div>
              <div className="flex items-start text-[0.9rem] text-gray-300">
                <p>
                  {selectedPlan.currency}
                  {selectedPlan.price}.00
                </p>
              </div>
            </section>
            <section className="w-full flex items-center justify-between border-b border-[#13141a] pb-[1rem]">
              <div className="flex flex-col gap-2">
                <p className="text-gray-300 text-[0.9rem] font-semibold">
                  Subtotal
                </p>
                <p className="text-gray-300 text-[0.9rem] font-semibold">Tax</p>
                {couponDiscount > 0 && (
                  <p className="text-gray-300 text-[0.9rem] font-semibold">
                    Discount
                  </p>
                )}
              </div>
              <div className="flex flex-col gap-2 justify-between text-[0.9rem] text-gray-300">
                <p>
                  + {selectedPlan.currency}
                  {selectedPlan.price}.00
                </p>
                <p> + {selectedPlan.currency}0.00</p>
                {couponDiscount > 0 && (
                  <p className="text-gray-300 text-[0.9rem] font-semibold">
                    - {selectedPlan.currency}
                    {(selectedPlan.price * (couponDiscount / 100)).toFixed(2)}
                  </p>
                )}
              </div>
            </section>
            <section className="w-full flex items-center justify-between pb-[1rem]">
              <div className="flex flex-col gap-2">
                <p className="text-gray-300 text-[0.9rem] font-semibold">
                  Total due today
                </p>
              </div>
              <div className="flex flex-col gap-2 justify-between text-[0.9rem] text-gray-300">
                <p>
                  {selectedPlan.currency}{" "}
                  {couponDiscount
                    ? Math.abs(
                        selectedPlan.price -
                          (selectedPlan.price * (couponDiscount / 100)).toFixed(
                            2
                          )
                      ).toFixed(2)
                    : Number(selectedPlan.price).toFixed(2)}
                </p>
              </div>
            </section>
          </div>
        </div>

        {/* Right Section */}
        <div className="w-1/2 bg-[#1e1f2a] p-6 relative flex items-center justify-center">
          <div>{children}</div>
        </div>
      </main>
    </Modal>
  );
}
